import { IOrderBy } from "../../../../Global/Base/DataSources/Interfaces";
import { IWidgetResizeEvent } from "../../../UI.BaseControls/IEvent";
import { createElement, registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { DataGridSharedMethods } from "../../DataGridSharedMethods";
import { IDataGrid } from "../../IDataGrid";
import { Column } from "../Columns/Column";
import { HeaderCell } from "./HeaderCell";
import { HeaderRow } from "./HeaderRow";
import { IDataRowElement } from "./IDataRow";

export class FrozenHeaderRow extends HeaderRow {
    public fakeHeaderCells: Set<HTMLTableHeaderCellElement>;

    //#region Methods
    public override render(owner: IDataGrid<IDataRowElement>, columns: Array<Column>, orderBy: IOrderBy[]): void {
        this._clearHeader();
        this.fakeHeaderCells.clear();
        this._owner = owner;
        this.width = 0;
        for (let i = 0; i < columns.length; i++) {
            const column: Column = columns[i];
            if (!column.visible)
                continue;
            const headerCell = new HeaderCell(owner, i, column);
            this.width += headerCell.column.width;

            /*const fakeHeader = createElement({ type: "th", css: { width: headerCell.column.width + "px" }, classes: "fake-header-cell no-sort-item" }) as HTMLTableHeaderCellElement;

            if (!headerCell.column.width) {
                self.setTimeout(() => {
                    fakeHeader.style.width = headerCell.column.width + "px";
                }, 0);
            }
            column.addEventListener("resizabledrag", (e: IWidgetResizeEvent) => {
                fakeHeader.style.width = e.detail.width + "px";
            });
            this.fakeHeaderCells.add(fakeHeader);*/

            const indexOf = DataGridSharedMethods.orderByIndexOf(orderBy, column.orderAttrName);
            if (indexOf > -1)
                this.appendChild(headerCell.render(orderBy[indexOf].order));
            else
                this.appendChild(headerCell.render(null));
        }

        this.renderFakeHeaderCells(columns);
    }
    //#endregion Methods

    public renderFakeHeaderCells(columns: Array<Column>): void {
        this.fakeHeaderCells.clear();

        for (const column of columns) {
            if (column.visible) {
                const fakeHeader = createElement({ type: "th", css: { width: column.width + "px" }, classes: "fake-header-cell no-sort-item" }) as HTMLTableHeaderCellElement;

                if (!column.width) {
                    self.setTimeout(() => {
                        fakeHeader.style.width = column.width + "px";
                    }, 0);
                }

                if (column.resizableDragEventListener)
                    column.removeEventListener("resizabledrag", column.resizableDragEventListener);
                column.addEventListener("resizabledrag", column.resizableDragEventListener = (e: IWidgetResizeEvent) => {
                    fakeHeader.style.width = e.detail.width + "px";
                });
                this.fakeHeaderCells.add(fakeHeader);
            }
        }
    }

    protected override _constructor(): void {
        super._constructor();
        this.classList.add("frozen-header-row");
        this.fakeHeaderCells = new Set<HTMLTableHeaderCellElement>();
    }
}

registerCustomElement("tsc-frozenheaderrow", FrozenHeaderRow);
